var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecorationImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 120,
    viewBox: "0 0 241 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_24465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5 32H0.5V88.4H80.5V32Z",
    fill: "url(#paint0_linear_83_24465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3001 88.4C99.8745 88.4 112.5 75.7744 112.5 60.2C112.5 44.6256 99.8745 32 84.3001 32C68.7257 32 56.1001 44.6256 56.1001 60.2C56.1001 75.7744 68.7257 88.4 84.3001 88.4Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3 80.4999C95.5114 80.4999 104.6 71.4113 104.6 60.1999C104.6 48.9885 95.5114 39.8999 84.3 39.8999C73.0886 39.8999 64 48.9885 64 60.1999C64 71.4113 73.0886 80.4999 84.3 80.4999Z",
    fill: "#FFD200",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5 0H120.5V104H216.5V0Z",
    fill: "url(#paint1_linear_83_24465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 16H144.5V120H240.5V16Z",
    fill: "url(#paint2_linear_83_24465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5 16H144.5V104H216.5V16Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.235 64.4457C188.235 65.4494 188.144 66.4531 187.87 67.4568C187.505 68.8255 186.958 70.1029 186.228 71.2891C185.681 72.2016 184.859 73.0228 184.129 73.7528C181.574 76.2164 179.111 78.7713 176.556 81.2349C175.552 82.2386 174.366 83.0599 173.089 83.6986C172.359 84.0636 171.537 84.3373 170.716 84.611C169.53 84.8848 168.253 85.0673 166.975 84.976C166.245 84.976 165.515 84.8848 164.785 84.7023C164.055 84.5198 163.417 84.3373 162.687 84.0636C161.044 83.4248 159.675 82.4211 158.398 81.1437C157.394 80.14 156.664 79.045 156.117 77.7676C155.843 77.1289 155.569 76.3989 155.387 75.6689C155.113 74.4827 154.931 73.2053 154.931 72.0191C154.931 71.1066 155.113 70.1942 155.387 69.2817C156.026 67.0006 157.121 65.0844 158.763 63.442C161.409 60.7958 164.055 58.1497 166.701 55.5036C167.249 54.9561 167.979 54.6824 168.8 54.8649C169.53 55.0473 170.078 55.5036 170.351 56.1423C170.716 57.0548 170.534 57.9672 169.804 58.6972C167.249 61.2521 164.694 63.807 162.139 66.3618C161.5 67.0006 160.862 67.7305 160.497 68.5518C160.223 69.0992 160.04 69.6467 159.858 70.1942C159.584 70.9241 159.493 71.7454 159.493 72.5666C159.493 73.5703 159.675 74.4827 160.04 75.3952C160.679 77.0376 161.683 78.3151 163.143 79.2275C163.873 79.6838 164.603 80.0487 165.424 80.2312C166.336 80.505 167.34 80.5962 168.344 80.505C170.351 80.3225 172.085 79.41 173.545 77.9501C176.008 75.4864 178.472 73.0228 180.936 70.5592C181.483 70.0117 181.939 69.5555 182.396 68.9167C182.852 68.278 183.217 67.548 183.491 66.8181C183.764 65.9969 183.947 65.0844 183.856 64.1719C183.764 61.982 183.034 60.1571 181.574 58.6059C181.027 58.0585 180.753 57.3285 180.936 56.5073C181.118 55.7773 181.483 55.2298 182.213 54.9561C183.217 54.5911 184.038 54.7736 184.768 55.5948C185.589 56.5073 186.319 57.511 186.958 58.6059C187.414 59.4272 187.688 60.3396 187.962 61.2521C188.144 62.4383 188.235 63.442 188.235 64.4457Z",
    fill: "url(#paint3_linear_83_24465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.541 55.2299C172.541 54.1349 172.632 53.2224 172.815 52.31C173.271 50.2113 174.183 48.3864 175.643 46.8352C176.465 45.9228 177.377 45.1016 178.29 44.1891C180.297 42.1817 182.304 40.1743 184.312 38.1669C185.224 37.2544 186.228 36.5244 187.414 35.8857C188.235 35.4295 189.148 35.1557 189.969 34.882C191.155 34.6083 192.25 34.4258 193.436 34.4258C194.258 34.4258 195.079 34.517 195.809 34.6995C197.086 34.9733 198.181 35.4295 199.276 36.0682C200.736 36.8894 201.922 37.9844 202.926 39.2618C203.656 40.1743 204.203 41.178 204.66 42.2729C204.933 42.9117 205.116 43.6416 205.298 44.3716C205.572 45.4665 205.663 46.5615 205.572 47.6564C205.481 48.5689 205.39 49.3901 205.207 50.3026C204.933 51.4888 204.386 52.5837 203.747 53.6787C203.108 54.6824 202.378 55.5948 201.557 56.4161C199.002 58.9709 196.447 61.5258 193.893 64.0807C193.345 64.6282 192.615 64.9019 191.794 64.7194C191.064 64.5369 190.516 64.0807 190.243 63.3507C189.878 62.4383 190.06 61.6171 190.79 60.8871C193.345 58.3322 195.9 55.7773 198.546 53.2224C199.185 52.5837 199.824 51.8538 200.28 51.0325C200.554 50.4851 200.736 49.9376 200.919 49.3901C201.192 48.4777 201.283 47.5652 201.192 46.6527C201.01 44.0066 199.732 41.9079 197.542 40.3568C196.904 39.9005 196.082 39.5356 195.353 39.3531C194.44 39.0793 193.436 38.9881 192.524 39.0793C191.429 39.1706 190.425 39.4443 189.422 39.9005C188.6 40.3568 187.87 40.813 187.232 41.4517C184.585 44.0979 181.939 46.744 179.293 49.3901C178.472 50.2113 177.833 51.1238 177.377 52.2187C176.921 53.4049 176.738 54.6824 176.83 55.9598C177.012 57.9672 177.833 59.6097 179.202 60.9784C180.206 62.0733 179.932 63.807 178.563 64.4457C177.742 64.9019 176.738 64.7194 176.008 63.9895C175.096 63.077 174.366 62.0733 173.818 60.8871C173.453 60.1571 173.18 59.4272 172.906 58.606C172.724 57.511 172.541 56.3248 172.541 55.2299Z",
    fill: "url(#paint4_linear_83_24465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 60C90.2958 60 84.5 65.7958 84.5 73C84.5 65.7958 78.7042 60 71.5 60C78.7042 60 84.5 54.2042 84.5 47C84.5 54.2042 90.35 60 97.5 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 34C163.513 34 159.5 38.0125 159.5 43C159.5 38.0125 155.488 34 150.5 34C155.488 34 159.5 29.9875 159.5 25C159.5 29.9875 163.55 34 168.5 34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5 88C202.175 88 199.5 90.675 199.5 94C199.5 90.675 196.825 88 193.5 88C196.825 88 199.5 85.325 199.5 82C199.5 85.325 202.2 88 205.5 88Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_24465",
    x1: 61.5,
    y1: 74,
    x2: 28,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_24465",
    x1: 216.5,
    y1: 52,
    x2: 120.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_83_24465",
    x1: 240.5,
    y1: 68,
    x2: 144.5,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83_24465",
    x1: 154.931,
    y1: 69.8883,
    x2: 188.235,
    y2: 69.8883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_83_24465",
    x1: 172.541,
    y1: 49.6008,
    x2: 205.606,
    y2: 49.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88C837"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_24465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationImage);
export default __webpack_public_path__ + "static/media/decoration-image.821fb7ebdd0d4c2f9f34a3c2ceab1ce9.svg";
export { ForwardRef as ReactComponent };